/**
 * Logger Utility
 *
 * Development-only logging wrapper. All console.* calls should go through
 * this module to prevent logging in production.
 *
 * Usage:
 *   import { logger } from '@/lib/logger'
 *   logger.log('Debug info')
 *   logger.error('Error occurred', error)
 *   logger.warn('Warning message')
 */

const isDev = import.meta.env.DEV

export const logger = {
  log: (...args: unknown[]) => {
    if (isDev) console.log(...args)
  },

  warn: (...args: unknown[]) => {
    if (isDev) console.warn(...args)
  },

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  error: (message: string, error?: unknown, _context?: Record<string, unknown>) => {
    // Always log errors — needed for production diagnostics (TestFlight/native).
    // Other channels (log/warn/debug/info) stay dev-only to avoid noise.
    console.error(message, error)
  },

  debug: (...args: unknown[]) => {
    if (isDev) console.debug(...args)
  },

  info: (...args: unknown[]) => {
    if (isDev) console.info(...args)
  },

  table: (data: unknown) => {
    if (isDev) console.table(data)
  },

  group: (label: string) => {
    if (isDev) console.group(label)
  },

  groupEnd: () => {
    if (isDev) console.groupEnd()
  },
}

export default logger
